import httpClient from "@/services/httpClient";
import {
    server, trademark_const
} from "@/services/constants";

export const getCHAGE_MASTER_RECORD_BYID = (id) => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.CHAGE_MASTER_RECORD + `/${id}`);
};
export const createCHAGE_MASTER_RECORD = (data) => {
    return httpClient.post(`${trademark_const.trademark_url}/` + server.CHAGE_MASTER_RECORD, data);
};

export const updateCHAGE_MASTER_RECORD = (id, data) => {
    return httpClient.put(`${trademark_const.trademark_url}/` + server.CHAGE_MASTER_RECORD + `/${id}`, data);
};